import { cn } from '@/lib/format';

interface UserAvatarProps {
  src: string;
  alt: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  ring?: boolean;
  className?: string;
}

const sizeMap: Record<NonNullable<UserAvatarProps['size']>, string> = {
  xs: 'w-6 h-6',
  sm: 'w-9 h-9',
  md: 'w-11 h-11',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24',
};

export default function UserAvatar({ src, alt, size = 'sm', ring = false, className }: UserAvatarProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center overflow-hidden rounded-full bg-background-200 shrink-0',
        ring && 'ring-2 ring-primary-300 ring-offset-2 ring-offset-background-50',
        sizeMap[size],
        className,
      )}
    >
      <img src={src} alt={alt} title={`${alt} 头像`} className="w-full h-full object-top" />
    </span>
  );
}